export default __webpack_public_path__ + "static/media/dry-stack.ef408f13.svg";